$('.logo_wrapper').slick({
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows:false,
   autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows:false
      }
    },
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows:false
      }
    }
  ]
});